/* hearth-parent-sticky.js — the sticky buy bar and its jump links.
   Added 24 Sep 2026. Decision (Ravi): "1B, 2A".
     Position: TOP on desktop (>= 750px), carrying the jump links;
               BOTTOM on phones, by the thumb, as before. Placement is CSS only
               (assets/hearth-parent-sticky.css).
     Timing:   the bar appears only once the main Add to Basket button has
               scrolled up OFF THE TOP of the screen. Before this, it showed
               whenever the button was out of view — including on page load,
               when the button is still further down — so two buy buttons
               competed from the first screen.

   HOW IT FITS WITH hearth-parent.js
     The bar's element id is "hp-stickybar", deliberately NOT "hp-sticky":
     the old IntersectionObserver in hearth-parent.js looks up "hp-sticky",
     finds nothing and stays out of the way. hearth-parent.js still owns the
     bar's price, variant line, button label/disabled state and the click
     that forwards to the main button — do not add a second click handler here.

   VERIFYING
     Use a VISIBLE browser tab. A background tab never fires the observer —
     that is how an earlier check wrongly concluded the bar "does not appear
     at desktop". Shopify's admin preview bar also covers the bottom of the
     screen for logged-in staff; customers do not get it. */
(function () {
  var bar = document.getElementById('hp-stickybar');
  var atc = document.getElementById('hp-atc');
  if (!bar || !atc) return;

  var deskMq = window.matchMedia ? window.matchMedia('(min-width: 750px)') : null;
  var reduceMq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function isDesk() { return !!(deskMq && deskMq.matches); }

  /* If the theme pins its own header to the top, sit below it rather than
     over it. Tall things (Shopify's full-screen admin preview iframe) and
     anything not at the very top are ignored. */
  function headerBottom() {
    if (!document.elementsFromPoint) return 0;
    var els = document.elementsFromPoint(window.innerWidth / 2, 1), best = 0;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el === bar || bar.contains(el)) continue;
      while (el && el !== document.body && el !== document.documentElement) {
        var pos = window.getComputedStyle(el).position;
        if (pos === 'fixed' || pos === 'sticky') {
          var r = el.getBoundingClientRect();
          if (el.tagName !== 'IFRAME' && r.top <= 1 && r.bottom > 0 && r.height < window.innerHeight * 0.4) {
            best = Math.max(best, r.bottom);
          }
          break;
        }
        el = el.parentElement;
      }
    }
    return Math.round(best);
  }

  var queued = false;
  function placeTop() {
    queued = false;
    bar.style.setProperty('--hp-sticky-top', (isDesk() ? headerBottom() : 0) + 'px');
  }
  function queueTop() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(placeTop);
  }

  function setOn(on) {
    if (on) placeTop();
    bar.classList.toggle('is-on', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
  }

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { setOn(!e.isIntersecting && e.boundingClientRect.top < 0); });
    }, { threshold: 0 }).observe(atc);
  } else {
    var check = function () { setOn(atc.getBoundingClientRect().bottom < 0); };
    window.addEventListener('scroll', check, { passive: true });
    check();
  }
  window.addEventListener('scroll', function () { if (bar.classList.contains('is-on')) queueTop(); }, { passive: true });
  window.addEventListener('resize', queueTop);

  /* JUMP LINKS — desktop only (hidden at 900px and below in CSS). Each link
     names a section KEY from the product template. A link whose section is
     missing or renders empty is dropped, so the bar never offers a jump to
     nothing; the rest are put in page order. To add one later (the editorial
     run), add <a data-jump="section-key"> in sections/hearth-parent.liquid. */
  var jump = document.getElementById('hp-jump');
  if (!jump) return;
  var kept = [];
  Array.prototype.slice.call(jump.querySelectorAll('a[data-jump]')).forEach(function (a) {
    var t = document.querySelector('[id^="shopify-section-"][id$="__' + a.getAttribute('data-jump') + '"]');
    if (!t || t.offsetHeight < 40) { a.parentNode.removeChild(a); return; }
    a.setAttribute('href', '#' + t.id);
    a._hpTarget = t;
    kept.push(a);
  });
  kept.sort(function (x, y) { return (x._hpTarget.compareDocumentPosition(y._hpTarget) & 4) ? -1 : 1; });
  kept.forEach(function (a) {
    jump.appendChild(a);
    a.addEventListener('click', function (ev) {
      ev.preventDefault();
      var t = a._hpTarget;
      var off = (isDesk() ? bar.offsetHeight + headerBottom() : 0) + 12;
      var y = t.getBoundingClientRect().top + window.pageYOffset - off;
      window.scrollTo({ top: Math.max(0, y), behavior: (reduceMq && reduceMq.matches) ? 'auto' : 'smooth' });
      if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1');
      try { t.focus({ preventScroll: true }); } catch (e) { /* older browsers */ }
    });
  });
  if (kept.length) jump.hidden = false;
})();
